@if (onDemandResponseSignal()?.scenario === onDemandScenarios.OnGoingCase) {
  <app-open-case
    [type]="type"
    [onDemandResponse]="onDemandResponseSignal()"
    [account]="account"
    (saveNoteTextChanged)="onNoteTextChanged($event)"
  ></app-open-case>
} @else {
  <div class="wrapper">
    <app-video-background
      class="survey-video"
      [source]="videoName"
      [background]="background"
      [showLogo]="!isMobile"
      [showAnonymous]="false"
    >
      <a class="header-back back-button" (click)="goBack()">
        <i class="fa-solid fa-chevron-left"></i>
        <div class="back text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
      </a>
      <div class="content">
        <app-pill
          class="pill-mini"
          [class.expanded]="pillExpanded"
        >
          <app-feature-pill-menu
            #pillMenu
            class="pill-menu"
            [pillMini]="true"
            (expandedChange)="pillExpanded = $event"
          ></app-feature-pill-menu>
        </app-pill>

        @if(onDemandResponseSignal()?.scenario === onDemandScenarios.NoNeedToRetakeSurvey) {
          @if(callConfirmedSignal()) {
            <div class="title-container">
              <div class="circle big">
                <i class="fa fa-solid fa-check"></i>
              </div>
  
              <div class="title booked">{{ 'WebApp.v1.OnDemand.CallBooked' | translate }}</div>
              <div class="description">{{ 'WebApp.v1.OnDemand.CallBooked.Description' | translate }}</div>
  
            </div>
          } @else {
            <div class="title-container">
              <div class="title">{{ 'WebApp.v1.OnDemand.RequestCall' | translate }}</div>
              <div class="description on-demand-markdown" [innerHTML]="onDemandResponseSignal()?.labels?.['App.v2.Views.' + labelsKey + '.InfoText'] | markdown"></div>

              <div class="why">
                <div class="read-why" (click)="scrollToHowItWorks()">{{ onDemandResponseSignal()?.labels?.['App.v2.Views.OnDemandPsychologist.Here'] }}</div>
                @if (type === 'mind') {
                  <span class="white-slash">/</span>
                  <div class="play-why" (click)="openHowdyVideo()"><i class="fa-solid fa-play"></i></div>
                }
              </div>

              <div class="button-container">
                <app-button
                  class="button"
                  [label]="'WebApp.v1.Shared.Buttons.Confirm' | translate"
                  [iconLeft]="this.progressBarIcon"
                  [fontSize]="24"
                  (click)="onCallRequest()"
                ></app-button>
  
                <app-button
                  class="button cancel"
                  [label]="'WebApp.v1.Shared.Buttons.Cancel' | translate"
                  iconLeft="fa-solid fa-ban"
                  iconColor="#C53333"
                  [fontSize]="24"
                  backgroundColor="transparent"
                  (click)="onCancelCallRequest()"
                ></app-button>
              </div>
            </div>
          }
        } @else if (onDemandResponseSignal()?.scenario === onDemandScenarios.NeedToRetakeSurvey) {
          <div class="title-container">
            <div class="title">{{ onDemandResponseSignal()?.labels?.['App.v2.Views.' + labelsKey + '.Title'] }}</div>
            <div class="description" [innerHTML]="descriptionLabel | markdown"></div>
  
            <div class="why">
              <div class="read-why" (click)="scrollToHowItWorks()">{{ onDemandResponseSignal()?.labels?.['App.v2.Views.OnDemandPsychologist.Here'] }}</div>
              @if (type === 'mind') {
                <span class="white-slash">/</span>
                <div class="play-why" (click)="openHowdyVideo()"><i class="fa-solid fa-play"></i></div>
              }
            </div>

            <app-button
              class="button"
              [label]="'WebApp.v1.Shared.Buttons.Start' | translate"
              [iconLeft]="this.progressBarIcon"
              [fontSize]="24"
              (click)="onNavigateToSurvey()"
            ></app-button>
          </div>
        } @else if (onDemandResponseSignal()?.scenario === onDemandScenarios.ReachedLimit) {
          <div class="title-container">
            <div class="title">{{ 'WebApp.v1.OnDemand.ReachedLimit' | translate }}</div>
            <div class="description">
              {{ onDemandResponseSignal()?.labels?.['App.v2.Views.OnDemandPsychologist.CallLimit'] }}
            </div>

            <div class="why">
              <div class="read-why" (click)="scrollToHowItWorks()">{{ onDemandResponseSignal()?.labels?.['App.v2.Views.OnDemandPsychologist.Here'] }}</div>
              @if (type === 'mind') {
                <span class="white-slash">/</span>
                <div class="play-why" (click)="openHowdyVideo()"><i class="fa-solid fa-play"></i></div>
              }
            </div>
          </div>
        }

        <div class="footer">
          <div class="footer-text"> {{ 'WebApp.v1.OnDemand.Footer' | translate: { companyName: account?.companyName } }}</div>

          @if (showHowItWorks) {
            <i class="fa-regular fa-chevron-down" (click)="scrollToHowItWorks()"></i>
          }
        </div>
      </div>
    </app-video-background>

    @if (showHowItWorks) {
      <div #howItWorks class="how-it-works">
        <div class="title-container">
          <div class="title">{{ 'WebApp.v1.OnDemand.Body.HowItWorks.Title' | translate }}</div>
          <div class="description">{{ 'WebApp.v1.OnDemand.Body.HowItWorks.Description' | translate: { companyName: account?.companyName } }}</div>
        </div>

        <div class="steps-container">
          @for (step of [1, 2]; track $index) {
            <div class="step">
              <div class="step-number">{{ $index + 1 }}</div>
              <div class="step-text">{{ 'WebApp.v1.OnDemand.' + stepType + '.Step' + ($index + 1) | translate }}</div>
            </div>
          }
        </div>
      </div>

      <div class="success-stories">
        <app-video-background
          class="survey-video"
          source="beach_with_waves"
          [background]="successStoriesBackground"
          [showLogo]="false"
          [showAnonymous]="false"
        >
          <div class="carousel-container">
            <div class="quote-icon">
              <i class="fa-solid fa-quote-right"></i>
            </div>
            
            <div class="quote-content">
              <div #quoteText class="quote-text">
                {{ successStoriesQuotes[currentQuoteIndex].text }}
              </div>
              <div #quoteAuthor class="quote-author">
                {{ successStoriesQuotes[currentQuoteIndex].author }}
              </div>
            </div>
            
          </div>
          <div class="carousel-dots">
            @for (quote of successStoriesQuotes; track $index) {
              <div 
                class="dot" 
                [class.active]="$index === currentQuoteIndex"
                (click)="goToQuote($index)"
              ></div>
            }
          </div>
        </app-video-background>
      </div>
    }
  </div>

  @if (showResponseTeamVideo || fadeOut) {
    <div class="video-container howdy-video" [class.fade-out]="fadeOut" [class.fade-in]="fadeIn">
      <i class="fa-solid fa-xmark close-button" (click)="closeHowdyVideo()"></i>
      <video class="video" controls autoplay>
        <source [src]="s3BaseUrl + 'assets/videos/responseTeamIntro' + languageId + videoFormat" type="video/mp4">
      </video>
    </div>
  }
}
